import { Link, NavigateFunction, useNavigate } from "react-router-dom";
import { ConfigProvider, Menu } from "antd";
import { NAVBAR_ITEMS_KEYS } from "@Constants/navbar";
import { NavigationRoutes } from "../../navigation/NavigationRoutes";
import Logo from "@Assets/images/main-logo.png";
import DashboardIcon from "@Assets/icons/dashboard-icon.svg";
import UserManagementIcon from "@Assets/icons/users-icon.svg";
import SubscriptionIcon from "@Assets/icons/subscription-icon.svg";
import TreeImage from "@Assets/images/tree-side-image.png";

const navItemsClassActive =
  "!font-Nunito !text-white !font-semibold !text-[1rem]";
const navItemsClassInactive =
  "!font-Nunito !text-white !font-medium !text-[1rem]";
const iconWrapperClass = "w-5 h-5 flex items-center justify-center";

const SideBar = ({
  route,
  selectedKey,
}: {
  route: string[];
  selectedKey: string;
  navigate: NavigateFunction;
}) => {
  const sidebarMenu = [
    {
      key: NAVBAR_ITEMS_KEYS.DASHBOARD,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.DASHBOARD
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          Dashboard
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.DASHBOARD ? (
          <div className={iconWrapperClass}>
            <DashboardIcon />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <DashboardIcon />
          </div>
        ),
    },
    {
      key: NAVBAR_ITEMS_KEYS.USER_MANAGEMENT,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.USER_MANAGEMENT}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.USER_MANAGEMENT
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          User Management
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.USER_MANAGEMENT ? (
          <div className={iconWrapperClass}>
            <UserManagementIcon />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <UserManagementIcon />
          </div>
        ),
    },
    {
      key: NAVBAR_ITEMS_KEYS.SUBSCRIPTION_MANAGEMENT,
      label: (
        <Link
          to={NavigationRoutes.DASHBOARD_ROUTES.SUBSCRIPTION}
          className={
            selectedKey === NAVBAR_ITEMS_KEYS.SUBSCRIPTION_MANAGEMENT
              ? navItemsClassActive
              : navItemsClassInactive
          }
        >
          Subscription Management
        </Link>
      ),
      icon:
        selectedKey === NAVBAR_ITEMS_KEYS.SUBSCRIPTION_MANAGEMENT ? (
          <div className={iconWrapperClass}>
            <SubscriptionIcon />
          </div>
        ) : (
          <div className={iconWrapperClass}>
            <SubscriptionIcon />
          </div>
        ),
    },
  ];

  const navigate = useNavigate();

  return (
    <div className="!bg-[#1F3D2B] w-[var(--side-bar-width)] min-w-[var(--side-bar-width)] max-w-[var(--side-bar-width)] h-full text-left navbar-items border-r z-10 border-strokeBorder flex flex-col">
      <div className="flex flex-col justify-between h-full flex-1 overflow-hidden">
        <div
          className="cursor-pointer flex-shrink-0 pl-4 text-right flex items-center justify-center pt-6 mb-2"
          onClick={() => navigate(NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD)}
        >
          <img src={Logo} width={150} height={70} alt="Story Tree Logo" />
        </div>

        <div className="relative flex-1 overflow-y-auto py-4 !font-Nunito">
          <ConfigProvider
            theme={{
              components: {
                Menu: {
                  itemSelectedBg: "#8B6A45",
                  itemSelectedColor: "white",
                  itemMarginInline: 8,
                  itemMarginBlock: 9,
                  itemHeight: 46,
                  itemBorderRadius: 12,
                  itemHoverBg: "#8B6A45",
                },
              },
            }}
          >
            <Menu
              mode="inline"
              theme={"light"}
              className="!font-Nunito !text-[1rem] sidebar-menu relative z-20"
              style={{ background: "#1F3D2B" }}
              items={sidebarMenu.map((item) => ({
                key: item.key,
                icon: item.icon,
                label: item.label,
              }))}
              selectedKeys={route.length ? [selectedKey] : ["dashboard"]}
            />

            <div className="absolute !left-[-12px] bottom-0 w-full px-4 z-0 pointer-events-none">
              <img
                src={TreeImage}
                alt="Tree Side"
                className="w-80 h-80 2xl:w-full 2xl:h-full pointer-events-none"
              />
            </div>
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
